import { render } from "./ReceivePaymentData.vue?vue&type=template&id=0e890d9e&scoped=true"
import script from "./ReceivePaymentData.vue?vue&type=script&lang=js"
export * from "./ReceivePaymentData.vue?vue&type=script&lang=js"

import "./ReceivePaymentData.vue?vue&type=style&index=0&id=0e890d9e&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e890d9e"]])

export default __exports__